import { permissions, registerBackNavigationHook } from '~/shared/lib'

import {
  resolveSupersededProjectBackFallback,
  shouldSkipBackToSupersededProjectRoute,
} from './projectRouteBackNavigation'

export function registerProjectRouteBackNavigation() {
  registerBackNavigationHook({
    shouldForceFallback: ({ backUrl }) => shouldSkipBackToSupersededProjectRoute(backUrl),
    resolveFallback: ({ currentUrl }, fallbackRoute) =>
      resolveSupersededProjectBackFallback(
        fallbackRoute,
        currentUrl,
        permissions.PROJECTS.MY.ROUTE,
      ),
  })
}
